"use strict";
var appn;
(function (appn) {
    var dataTable;
    (function (dataTable) {
        dataTable.FILTER_RESET_BTN = `<button class="btn btn-tool btn-resetFilters" type="button" title="${T('Reset Filters')}"><i class="fa fa-sync-alt"></i></button>`;
        const _datatableCheckAllBoxSelector = 'table.dataTable thead tr th input[type="checkbox"]';
        dataTable.stateKeyPrefix = 'appn.dataTablesState.' + window.location.pathname + '.';
        function getCompositeStateCacheKey(oSettings, suffix) {
            if (suffix)
                return appn.dataTable.stateKeyPrefix + oSettings.sInstance + suffix;
            return appn.dataTable.stateKeyPrefix + oSettings.sInstance;
        }
        dataTable.getCompositeStateCacheKey = getCompositeStateCacheKey;
        function constructDataTableFooter() {
            const dataTableWrappers = $('.card .card-body').find('.dataTables_wrapper');
            dataTableWrappers.each(function () {
                const dataTableWrapper = $(this);
                if (dataTableWrapper.find('.dataTables_footer').length)
                    return;
                const $controls = dataTableWrapper.find('.dataTables_length, .dataTables_info, .dataTables_paginate');
                const $ownControls = $controls.filter(function () {
                    return $(this).closest('.dataTables_wrapper').is(dataTableWrapper);
                });
                if ($ownControls.length) {
                    $('<div/>', {
                        class: 'dataTables_footer'
                    }).appendTo(dataTableWrapper);
                    $ownControls.appendTo(dataTableWrapper.find('.dataTables_footer'));
                }
            });
        }
        dataTable.constructDataTableFooter = constructDataTableFooter;
        function revealDataTable() {
            constructDataTableFooter();
            $('.dataTables_filter,.dataTables_scroll,table.dataTable.table,.dataTables_length,.dataTables_info,.dataTables_paginate').css('opacity', 1);
        }
        dataTable.revealDataTable = revealDataTable;
        function create(selector, cfg) {
            const isServer = cfg.sAjaxSource ? true : false;
            const colResizeConfig = {
                isEnabled: true,
                saveState: false,
                hoverClass: 'dt-colresizable-hover',
                hasBoundCheck: true,
                minBoundClass: 'dt-colresizable-bound-min',
                maxBoundClass: 'dt-colresizable-bound-max'
            };
            const settingObj = {
                bServerSide: isServer,
                bProcessing: cfg.hasOwnProperty('bProcessing') ? cfg.bProcessing : true,
                bSort: cfg.hasOwnProperty('bSort') ? cfg.bSort : true,
                fixedHeader: cfg.hasOwnProperty('fixedHeader') ? cfg.fixedHeader : true,
                paging: cfg.hasOwnProperty('paging') ? cfg.paging : true,
                ordering: cfg.hasOwnProperty('ordering') ? cfg.ordering : true,
                info: cfg.hasOwnProperty('info') ? cfg.info : true,
                searching: cfg.hasOwnProperty('searching') ? cfg.searching : true,
                autoWidth: cfg.hasOwnProperty('autoWidth') ? cfg.autoWidth : false,
                hasFilters: cfg.hasOwnProperty('hasFilters') ? cfg.hasFilters : true,
                scrollY: cfg.hasOwnProperty('scrollY') ? cfg.scrollY : '70vh',
                scrollX: cfg.hasOwnProperty('scrollX') ? cfg.scrollX : '100%',
                sDom: cfg.hasOwnProperty('sDom') ? cfg.sDom : genSDom(),
                iDisplayLength: cfg.hasOwnProperty('iDisplayLength') ? cfg.iDisplayLength : 25,
                aLengthMenu: cfg.hasOwnProperty('aLengthMenu') ? cfg.aLengthMenu : [10, 25, 50, 100],
                oLanguage: {
                    oPaginate: {
                        sPrevious: '<i class="fa fa-chevron-left"></i>',
                        sNext: '<i class="fa fa-chevron-right"></i>'
                    },
                    sInfoFiltered: cfg.hasOwnProperty('sInfoFiltered') ? cfg.sInfoFiltered : appn.emptyString,
                    sSearch: appn.emptyString,
                    sInfoEmpty: appn.emptyString,
                    sEmptyTable: cfg.hasOwnProperty('sEmptyTable') ? cfg.sEmpty :
                        `<span class="dataTables_noData text-center lead text-gray"><span class="font-size-larger-2"><i class="fa fa-search text-danger mr-2"></i>${T('No Data Found')}</span>${(!cfg.hasOwnProperty('hasFilters') || cfg.hasFilters === true ? `<br><span class="font-size-smaller-1">${T(`Try <a href='#' class='link-reset-filters'>resetting</a> the filters`)}</span>` : appn.emptyString)}</span>`,
                    sProcessing: cfg.hasOwnProperty('sProcessing') ? cfg.sProcessing : appn.ui.getSpinner(),
                    sInfo: T("Showing _START_ to _END_ of _TOTAL_ entries"),
                    sLengthMenu: T("Show _MENU_ entries")
                },
                sAjaxSource: cfg.hasOwnProperty('sAjaxSource') ? cfg.sAjaxSource : null,
                fnServerData: !isServer ? null : function (url, data, callback) {
                    if (cfg.fnServerData)
                        cfg.fnServerData(data, callback);
                    appn.ajax.post({
                        url: url,
                        data: data,
                        done: function (data) {
                            callback(data);
                        },
                        fail: function (jqXHR, textStatus, errorThrown) {
                            $('div.dataTables_wrapper div.dataTables_processing').hide();
                            if (errorThrown === 'parsererror' || textStatus === 'parsererror')
                                errorThrown = T('An error occurred while retrieving data');
                            if (jqXHR.responseText && !jqXHR.responseText.startsWithIgnoreCase('<'))
                                errorThrown = jqXHR.responseText;
                            appn.toast.notify(appn.toast.Type.error, errorThrown);
                            revealDataTable();
                        }
                    });
                },
                aaSorting: cfg.hasOwnProperty('aaSorting') ? cfg.aaSorting : [[0, 'asc']],
                aoColumns: cfg.hasOwnProperty('aoColumns') ? cfg.aoColumns : null,
                aoColumnDefs: cfg.hasOwnProperty('aoColumnDefs') ? cfg.aoColumnDefs : null,
                createdRow: cfg.hasOwnProperty('createdRow') ? cfg.createdRow : null,
                oColVis: cfg.hasOwnProperty('oColVis') ? cfg.oColVis : null,
                oColReorder: cfg.hasOwnProperty('oColReorder') ? cfg.oColReorder : null,
                fnInitComplete: function () {
                    if (cfg.hasOwnProperty('fnInitComplete'))
                        cfg.fnInitComplete();
                    if (dt && dt.editor && cfg.editable) {
                        if (cfg.editable.canEdit) {
                            $('.dataTables_controls_end').prepend($('<button/>', {
                                id: 'btn-add-row',
                                class: 'btn btn-tool',
                                html: '<i class="fa fa-plus"></i> ' + T('Add Row')
                            }));
                        }
                    }
                    appn.select.init();
                    revealDataTable();
                    checkAllRowsAndToggle();
                    toggleOnRowChecked();
                    appn.tooltip.init();
                },
                fnDrawCallback: function () {
                    if (cfg.hasOwnProperty('fnDrawCallback'))
                        cfg.fnDrawCallback();
                    if (dt && dt.editor) {
                        dt.editor.reinjectClientAddedRows();
                        dt.editor.syncUIWithState();
                    }
                    checkAllRowsAndToggle();
                    toggleOnRowChecked();
                    appn.ui.tryResetFiltersEvent();
                },
                stateSave: cfg.hasOwnProperty('stateSave') ? cfg.stateSave : true,
                stateSaveCallback: function (oSettings, oData) {
                    if (cfg.stateSaveCallback) {
                        cfg.stateSaveCallback(oSettings, oData, getCompositeStateCacheKey(oSettings));
                        return;
                    }
                    try {
                        window.localStorage.setItem(getCompositeStateCacheKey(oSettings), JSON.stringify(oData));
                    }
                    catch (e) {
                    }
                },
                stateLoadCallback: function (oSettings, oData) {
                    if (cfg.stateLoadCallback)
                        return cfg.stateLoadCallback(oSettings, getCompositeStateCacheKey(oSettings));
                    const oDataStateObj = JSON.parse(window.localStorage.getItem(getCompositeStateCacheKey(oSettings)));
                    return oDataStateObj;
                },
                colResize: cfg.hasOwnProperty('colResize') ? cfg.colResize : colResizeConfig
            };
            let dt = null;
            if ($.fn.dataTable.isDataTable(selector))
                dt = $(selector).DataTable();
            if (dt) {
                dt.destroy();
                dt = null;
            }
            if (cfg.editable) {
                dt = { editor: new dataTable.Editor(cfg.editable) };
                if (!cfg.aoColumns)
                    settingObj.aoColumns = dt.editor.getMainColumns();
            }
            const $dt = $(selector).dataTable(settingObj);
            dt = $.extend($dt, dt);
            if (dt.editor) {
                dt.editor.init(dt);
            }
            if (!isServer)
                appn.dataTable.revealDataTable();
            if (!cfg.noFilterKey)
                $dt.fnSetFilterKey();
            return dt;
        }
        dataTable.create = create;
        function getStateOrDefault(name, defaultValue) {
            const pageStateRegister = appn.localStorage.getItem(appn.saveMeState.dbKey);
            const registerItem = appn.saveMeState.findItemInRegister(name, pageStateRegister);
            if (registerItem)
                return { name: name, value: registerItem.value };
            return { name: name, value: defaultValue };
        }
        dataTable.getStateOrDefault = getStateOrDefault;
        function checkAllRowsAndToggle() {
            const checkAllCheckBox = $(_datatableCheckAllBoxSelector);
            if (checkAllCheckBox.length === 0)
                return;
            checkAllCheckBox.off().on('change', function () {
                if ($(this).is(':checked') && $('.dataTable .selectRow').length > 0) {
                    $('.dataTable .selectRow:not(:disabled)').prop('checked', true);
                    appn.ui.enableElement($('.datatable-togglebtn'));
                }
                else {
                    $('.selectRow').prop('checked', false);
                    appn.ui.disableElement($('.datatable-togglebtn'));
                }
            });
        }
        dataTable.checkAllRowsAndToggle = checkAllRowsAndToggle;
        function toggleOnRowChecked() {
            const toggleBtn = $('.datatable-togglebtn');
            if (toggleBtn.length > 0)
                appn.ui.disableElement(toggleBtn);
            const selectRow = $('.selectRow');
            if (selectRow.length === 0)
                return;
            selectRow.off().on('change', function () {
                if ($(this).is(':checked')) {
                    appn.ui.enableElement($('.datatable-togglebtn'));
                    return;
                }
                if ($(_datatableCheckAllBoxSelector).is(':checked'))
                    $(_datatableCheckAllBoxSelector).prop('checked', false);
                if ($('.selectRow:checked').length === 0)
                    appn.ui.disableElement($('.datatable-togglebtn'));
            });
        }
        dataTable.toggleOnRowChecked = toggleOnRowChecked;
        function uncheckAllRowsBox() {
            $(_datatableCheckAllBoxSelector).prop('checked', false);
        }
        dataTable.uncheckAllRowsBox = uncheckAllRowsBox;
        function addSearchPlaceholder(hintText, hintClass, placement) {
            const searchInput = $('.dataTables_filter input[type="search"]');
            searchInput.attr('placeholder', T('Hit Enter to Search'));
            if (hintText)
                searchInput.attr('title', hintText);
        }
        dataTable.addSearchPlaceholder = addSearchPlaceholder;
        function clearSearch(tableSelector) {
            const table = $(tableSelector ? tableSelector : '.dataTable').DataTable();
            table.search(appn.emptyString);
            $('.feed-search-container #SearchId').val(appn.emptyString);
            appn.ui.disableElement($('.feed-search-container #SearchId'));
            $('.data-map-view #SearchId').val(appn.emptyString);
        }
        dataTable.clearSearch = clearSearch;
        function clearSearchData(data) {
            const searchIndex = data.findIndex((d) => d.name === 'sSearch');
            data[searchIndex].value = appn.emptyString;
            clearSearch();
            return data;
        }
        dataTable.clearSearchData = clearSearchData;
        function resetPaging(tableSelector) {
            const table = $(tableSelector ? tableSelector : '.dataTable').DataTable();
            table.page(0);
        }
        dataTable.resetPaging = resetPaging;
        function clearStateCacheFor(keyPrefix) {
            try {
                for (const key in window.localStorage)
                    if (key.substring(0, keyPrefix.length) === keyPrefix)
                        delete window.localStorage[key];
            }
            catch (e2) {
            }
        }
        dataTable.clearStateCacheFor = clearStateCacheFor;
        function redrawOnResize(timeDelayInMilli) {
            const $dataTable = $('.dataTable').not('.nested-table');
            if (!$dataTable.length)
                return;
            const datatableSettings = $dataTable.DataTable().settings().init();
            if (!datatableSettings)
                return;
            if (!timeDelayInMilli) {
                $dataTable.DataTable().columns.adjust();
                return;
            }
            setTimeout(function () {
                $dataTable.DataTable().columns.adjust();
            }, timeDelayInMilli);
        }
        dataTable.redrawOnResize = redrawOnResize;
        function genSDom(ratioLeft = 1, ratioMid = 0, ratioRight = 2, containerClasses = appn.emptyString, plugins = appn.emptyString, options = 'rtlip') {
            const total = ratioLeft + ratioMid + ratioRight;
            const leftContainer = ratioLeft > 0 ? `<'dataTables_controls_start r-${ratioLeft}'>` : appn.emptyString;
            const midContainer = ratioMid > 0 ? `<'dataTables_controls_mid r-${ratioMid}'>` : appn.emptyString;
            const rightContainer = ratioRight > 0 ? `<'dataTables_controls_end r-${ratioRight}'f>` : appn.emptyString;
            const containerBase = `dataTables_controls_container${(appn.utils.hasValue(containerClasses) ? ` ${containerClasses}` : appn.emptyString)}`;
            const containerEmpty = `dataTables_controls_container_empty${(appn.utils.hasValue(containerClasses) ? ` ${containerClasses}` : appn.emptyString)}`;
            const containerWrapper = total > 0 ? `'${containerBase}'` : `'${containerEmpty}'`;
            return `${plugins}<${containerWrapper}${leftContainer}${midContainer}${rightContainer}>${options}`;
        }
        dataTable.genSDom = genSDom;
    })(dataTable = appn.dataTable || (appn.dataTable = {}));
})(appn || (appn = {}));
